import type { Price } from "../Price.js";
import type { ProductForCustomer } from "../Product.js";
import type { ProductSize } from "../ProductSize.js";
import { productSizeKeyMap } from "../productSizeKeyMap.js";

export function getPriceForProductForCustomerOfSize(product: ProductForCustomer, size: ProductSize): Price | undefined {
	const sizeKey = productSizeKeyMap[size];
	return product.priceForCustomer[sizeKey];
}
